import ebikeRight from "../../Images/ebikeRight-w1200.jpg";

const WhyChooseVelosure = () => {
  return (
    <div className="container-fluid bg-lightgreen pt-4 pb-5  pr oh">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h3 className="pt-4">Why choose Velosure for</h3>
            <h3 className="pb-4 ">
              <span className="greenFont">your e-bike </span>cover?
            </h3>
          </div>
          <div className="col-sm-9 col-12">
            <p className="greenFont">
              Our electric bicycle insurance policy includes all the key
              features you shouldn't go without, minus the high price tag
              associated with other bicycle insurance products.
            </p>
            <p className="mb-5">
              We have worked hard to give you an e-bike insurance quote that
              reflects how your electric cycle will be used, so you aren't
              paying for unnecessary extras or missing out on important
              features.
            </p>

            <div className="row">
              <div id="left" className="col-12 col-sm-6">
                <svg width="83" height="82" viewBox="0 0 83 82">
                  <defs>
                    <filter
                      id="Rectangle_749"
                      x="4"
                      y="4"
                      width="79"
                      height="78"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_748"
                      x="0"
                      y="0"
                      width="78"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path">
                      <rect
                        id="Rectangle_794"
                        data-name="Rectangle 794"
                        width="41.942"
                        height="43.925"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_2583"
                    data-name="Group 2583"
                    transform="translate(-19 -2537)"
                  >
                    <g
                      transform="matrix(1, 0, 0, 1, 19, 2537)"
                      filter="url(#Rectangle_749)"
                    >
                      <rect
                        id="Rectangle_749-2"
                        data-name="Rectangle 749"
                        width="67"
                        height="66"
                        rx="17"
                        transform="translate(10 7)"
                        fill="rgba(123,193,11,0.3)"
                      />
                    </g>
                    <g
                      transform="matrix(1, 0, 0, 1, 19, 2537)"
                      filter="url(#Rectangle_748)"
                    >
                      <rect
                        id="Rectangle_748-2"
                        data-name="Rectangle 748"
                        width="66"
                        height="67"
                        rx="17"
                        transform="translate(6 3)"
                        fill="#86bb2f"
                      />
                    </g>
                    <g
                      id="Group_1759"
                      data-name="Group 1759"
                      transform="translate(37.133 2551.449)"
                    >
                      <g
                        id="Group_1759-2"
                        data-name="Group 1759"
                        transform="translate(0 0)"
                        clipPath="url(#clip-path)"
                      >
                        <path
                          id="Path_2082"
                          data-name="Path 2082"
                          d="M10.1,13.249H41.81a1,1,0,0,0,0-1.992h-3.8L36.219,5.61C35.253,2.567,34.3.991,33.046.341s-2.483-.25-3.788.171a10.434,10.434,0,0,1-3.3.654A10.441,10.441,0,0,1,22.647.511c-1.3-.42-2.536-.816-3.786-.17S16.655,2.567,15.69,5.61L13.9,11.257H10.1a1,1,0,0,0,0,1.992m5.889-1.992,1.6-5.044c.758-2.392,1.474-3.734,2.187-4.1.515-.265,1.246-.03,2.264.3a12.252,12.252,0,0,0,3.915.75,12.264,12.264,0,0,0,3.924-.753c1.01-.324,1.741-.561,2.256-.294.713.368,1.429,1.71,2.187,4.1l1.6,5.044Z"
                          transform="translate(-4.983 0)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2083"
                          data-name="Path 2083"
                          d="M23.841,34.131a1,1,0,0,0-1,1,5.159,5.159,0,0,0,10.221,1h.822a5.159,5.159,0,0,0,10.221-1,1,1,0,0,0-1-1Zm18.116,1.992a3.167,3.167,0,0,1-6.012,0Zm-10.947,0a3.167,3.167,0,0,1-6.012,0Z"
                          transform="translate(-12.506 -18.684)"
                          fill="#fff"
                        />
                        <path
                          id="Path_2084"
                          data-name="Path 2084"
                          d="M41.87,61.872a.987.987,0,0,0-.531-.546l-9.539-4.1,1.448-4.591a1,1,0,0,0-.95-1.295H9.643a1,1,0,0,0-.95,1.3l1.448,4.591L.6,61.326a1,1,0,0,0,.029,1.842.979.979,0,0,0,.758-.013L11.756,58.7a.992.992,0,0,0,.556-1.213L11,53.33h8.972v17.7a1,1,0,1,0,1.992,0V53.33h8.972l-1.31,4.154a.993.993,0,0,0,.556,1.214L40.55,63.155a1.019,1.019,0,0,0,1.311-.52.99.99,0,0,0,.01-.763"
                          transform="translate(0 -28.104)"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </svg>

                <h4>
                  Theft & Accidental <br /> damage
                </h4>
                <p className="mb-5 pr-5">
                  We will cover your electric bike for accidental damage when
                  things go wrong, giving you complete peace of mind whilst
                  using your bicycle. Plus, you’ll be covered for theft and
                  aggravated theft, including a replacement e-bike during the
                  claims process.
                </p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="83"
                  height="82"
                  viewBox="0 0 83 82"
                >
                  <defs>
                    <filter
                      id="Rectangle_1157"
                      x="4"
                      y="4"
                      width="79"
                      height="78"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1156"
                      x="0"
                      y="0"
                      width="78"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path88">
                      <rect
                        id="Rectangle_797"
                        data-name="Rectangle 797"
                        width="50.645"
                        height="42.448"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1157)"
                  >
                    <rect
                      id="Rectangle_1157-2"
                      data-name="Rectangle 1157"
                      width="67"
                      height="66"
                      rx="17"
                      transform="translate(10 7)"
                      fill="rgba(123,193,11,0.3)"
                    />
                  </g>
                  <g
                    transform="matrix(1, 0, 0, 1, 0, 0)"
                    filter="url(#Rectangle_1156)"
                  >
                    <rect
                      id="Rectangle_1156-2"
                      data-name="Rectangle 1156"
                      width="66"
                      height="67"
                      rx="17"
                      transform="translate(6 3)"
                      fill="#86bb2f"
                    />
                  </g>
                  <g
                    id="Group_2054"
                    data-name="Group 2054"
                    transform="translate(13.678 13.449)"
                  >
                    <g
                      id="Group_1762"
                      data-name="Group 1762"
                      transform="translate(0 0)"
                      clip-path="url(#clip-path88)"
                    >
                      <path
                        id="Path_2094"
                        data-name="Path 2094"
                        d="M30.261,34.324a14.765,14.765,0,0,1,.84,3.955l.007.193H27.861L27.809,37.3c-.03-.341-.078-.675-.122-1.011a8.171,8.171,0,0,1-1.489.554c.042.373.078.748.1,1.128l.016.506H20.788l-.05-2.061a8.229,8.229,0,0,1-1.61-.953c.015.255.034.512.045.764l.056,2.249H13.465l.055-2.245c.046-.962.117-1.931.211-2.878l.111-.961.367.036c.728.046,1.553.062,2.451.038a8.153,8.153,0,0,1-.564-1.545l-.192,0c-.521,0-1.047-.017-1.6-.051l-.248-.022.014-.1c.126-.813.274-1.57.439-2.249A12.662,12.662,0,0,1,15.6,25.362c.336-.6.585-.761.654-.793l.1-.028.066.013a1.205,1.205,0,0,1,.409.386A8.287,8.287,0,0,1,18.2,23.091a16.352,16.352,0,0,0-1.857-.109L15.509,23a16.286,16.286,0,0,0-11,5.058l-.121.138-.118.051-.036.022a.845.845,0,0,0-.221.248l-.071.193-.426.492A16.164,16.164,0,0,0,0,39.326,16.334,16.334,0,0,0,15.514,55.654l.832.022h0A16.339,16.339,0,0,0,31.335,32.8a8.267,8.267,0,0,1-1.074,1.521M20.513,45.466c.094-.941.167-1.939.219-2.971l.058-2.472h5.528l-.02.668a19.615,19.615,0,0,1-1.325,6.11l-.273.621-.673-.257a22.188,22.188,0,0,0-3.04-.8l-.568-.09Zm-1.279-5.443-.061,2.407c-.043.951-.114,1.919-.209,2.875l-.085.752-1.218-.113c-.544-.038-1.118-.057-1.755-.057-.556,0-1.126.016-1.7.047l-.4.041-.076-.668c-.094-.943-.166-1.911-.212-2.874l-.059-2.411ZM14.058,24.939a15.4,15.4,0,0,0-1.067,3.2c-.163.67-.316,1.442-.466,2.364l-.024.184L11.258,30.5a20.8,20.8,0,0,1-2.578-.644L8.7,29.8a10.464,10.464,0,0,1,5.353-4.863m-1.873,8.251c-.1.948-.17,1.947-.216,2.971l-.056,2.31H6.381l.016-.507a19.637,19.637,0,0,1,1.327-6.116l.258-.588.034.013a22.447,22.447,0,0,0,2.963.755l1.313.2Zm.077,12.944-1.288.2a22.828,22.828,0,0,0-2.965.753l-.13.049-.15-.339A19.793,19.793,0,0,1,6.4,40.691l-.021-.667h5.533l.06,2.475c.046,1.012.118,2.01.217,2.97ZM6.149,28.625a14.7,14.7,0,0,1,3.146-2.3l.04-.02a14.4,14.4,0,0,0-1.624,2.139l-.484.878c-.389-.162-.757-.332-1.09-.5l-.112-.063ZM1.6,38.284a14.639,14.639,0,0,1,3.223-8.217l.121-.135.478.273c.4.2.757.364,1.124.518l-.4.923A21.665,21.665,0,0,0,4.887,37.3l-.05,1.172-3.242,0H1.589Zm3.17,10.241A14.671,14.671,0,0,1,1.6,40.378l-.014-.361,3.246.007.059,1.332A21.516,21.516,0,0,0,6.154,47l.3.681-1.038.477ZM9.3,52.334A14.711,14.711,0,0,1,6.155,50.04l-.31-.337.281-.159.981-.45.621,1.111a14.228,14.228,0,0,0,1.644,2.162Zm-.586-3.49-.155-.3a21.809,21.809,0,0,1,2.693-.683l1.2-.185.067.479c.149.909.3,1.681.465,2.358a15.532,15.532,0,0,0,1.068,3.2,10.54,10.54,0,0,1-5.342-4.868m9.478,1.313A12.885,12.885,0,0,1,17.1,53.291a1.872,1.872,0,0,1-.654.8l-.1.025-.073-.017c-.092-.041-.342-.2-.678-.808a12.419,12.419,0,0,1-1.09-3.133c-.165-.684-.313-1.441-.439-2.247l-.056-.391.287-.025c.511-.034,1.052-.051,1.608-.051.593,0,1.136.017,1.657.053l1.113.1-.047.309c-.122.785-.269,1.542-.433,2.249m.439,3.562a15.547,15.547,0,0,0,1.074-3.2c.167-.713.322-1.506.463-2.363l.045-.339.489.078a20.769,20.769,0,0,1,2.807.741l.492.19-.013.027a10.454,10.454,0,0,1-5.358,4.87m4.772-1.389-.051.024a14.307,14.307,0,0,0,1.629-2.143l.436-.785.506.241.619.371a14.821,14.821,0,0,1-3.139,2.291m7.7-11.958a14.691,14.691,0,0,1-3.221,8.216l-.26.282-.954-.568-.554-.265.441-1.027a21.577,21.577,0,0,0,1.256-5.654l.06-1.334h3.245Z"
                        transform="translate(0 -13.227)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2095"
                        data-name="Path 2095"
                        d="M68.829,8.944a6.355,6.355,0,0,0-2.493.508l-.049.023L65.5,5.632l1.016-.28a.755.755,0,0,0,.487-.409l.752-1.575a.767.767,0,0,0-.317-1L63.375.1a.766.766,0,0,0-.587-.065.749.749,0,0,0-.451.362.764.764,0,0,0,.294,1.041L64.9,2.7,62.812,2a.763.763,0,0,0-.586.042.752.752,0,0,0-.382.436.77.77,0,0,0,.478.972l2.4.809-.315.087a.765.765,0,0,0-.547.89l.2.961-8.4,1.808-.55-1.949.023,0a5.8,5.8,0,0,0,1.375-.172A.765.765,0,0,0,56.139,4.4a3.953,3.953,0,0,1-2.2-.062,7.417,7.417,0,0,1-2.091-1.1.747.747,0,0,0-.57-.129.763.763,0,0,0-.313,1.376,8.846,8.846,0,0,0,2.482,1.3l.486,1.728-1.7,2.241-.059-.037a6.4,6.4,0,1,0,3.062,7.525l.037-.145,1.241.17L58.65,19.51l-.359.4a.768.768,0,0,0,.548,1.273.766.766,0,0,0,.6-.257l1.669-1.89a.765.765,0,1,0-1.146-1.013l-.3.337L58.22,16.844,64.8,9.836l.079.383a.667.667,0,0,0,.029.108l-.6.5a6.4,6.4,0,1,0,4.524-1.879M65.772,3.233c-.011-.021-.021-.041-.033-.06l.334.187-.293.611-.05.014a.8.8,0,0,0,.081-.167.759.759,0,0,0-.038-.584M53.61,17.244a4.873,4.873,0,1,1-4.491-6.77,4.778,4.778,0,0,1,1.883.38l.282.153-3.023,3.986a.766.766,0,0,0,.5,1.223l4.956.673Zm.378-1.86-3.719-.508,2.271-3,.025.02a4.845,4.845,0,0,1,1.429,3.429Zm1.6-1.3a.749.749,0,0,0-.238-.161l-.122-.476a6.453,6.453,0,0,0-1.6-2.63l-.173-.142,1-1.311,1.411,5.009Zm2.091,1.1-1.606-5.7L64.365,7.7,64.427,8Zm11.145,5.037a4.875,4.875,0,0,1-3.457-8.306l.264-.217.332.611-.261.208a4.714,4.714,0,0,0-1.054,1.522.762.762,0,0,0,.393,1.008.872.872,0,0,0,.293.067.773.773,0,0,0,.713-.459,3.191,3.191,0,0,1,.659-.981l1.334,2.468a.772.772,0,0,0,.641.4.717.717,0,0,0,.1-.006.783.783,0,0,0,.287-.089.764.764,0,0,0,.31-1.036l-1.4-2.57a.775.775,0,0,0,.266-.925.765.765,0,0,0-.424-.411.751.751,0,0,0-.564,0l-.347-.642.008,0a4.813,4.813,0,0,1,1.9-.387,4.873,4.873,0,1,1,0,9.745"
                        transform="translate(-24.587 0)"
                        fill="#fff"
                      />
                      <path
                        id="Path_2096"
                        data-name="Path 2096"
                        d="M51.6,27.689a.756.756,0,0,0-.006-.59.747.747,0,0,0-.407-.409.763.763,0,0,0-.59,0,4.782,4.782,0,0,0-2.608,2.526.772.772,0,0,0,.683,1.074H48.7a.753.753,0,0,0,.7-.458,3.266,3.266,0,0,1,1.8-1.734.745.745,0,0,0,.411-.411"
                        transform="translate(-27.584 -15.328)"
                        fill="#fff"
                      />
                    </g>
                  </g>
                </svg>
                <h4>
                  European <br />
                  cover
                </h4>
                <p className="pr-5">
                  You're able to take your e-bike anywhere in Europe for up to
                  90 consecutive days and be covered.
                </p>
                <p className="pr-5 mb-5">
                  <span style={{ fontWeight: 600 }}>
                    Travelling outside the European Union?
                  </span>{" "}
                  <br />
                  You can add World-Wide cover to your e-bike cover policy and
                  enjoy complete protection for 90 consecutive days.
                </p>
              </div>

              <div className="col-12 col-sm-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="83"
                  height="82"
                  viewBox="0 0 83 82"
                >
                  <defs>
                    <filter
                      id="Rectangle_1159"
                      x="4"
                      y="4"
                      width="79"
                      height="78"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur" />
                      <feFlood floodOpacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <filter
                      id="Rectangle_1158"
                      x="0"
                      y="0"
                      width="78"
                      height="79"
                      filterUnits="userSpaceOnUse"
                    >
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="2" result="blur-2" />
                      <feFlood floodOpacity="0.031" />
                      <feComposite operator="in" in2="blur-2" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                    <clipPath id="clip-path99">
                      <rect
                        id="Rectangle_1160"
                        data-name="Rectangle 1160"
                        width="34.984"
                        height="44.44"
                        fill="#fff"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Group_2584"
                    data-name="Group 2584"
                    transform="translate(-18 -2834)"
                  >
                    <g id="Group_2585" data-name="Group 2585">
                      <g
                        transform="matrix(1, 0, 0, 1, 18, 2834)"
                        filter="url(#Rectangle_1159)"
                      >
                        <rect
                          id="Rectangle_1159-2"
                          data-name="Rectangle 1159"
                          width="67"
                          height="66"
                          rx="17"
                          transform="translate(10 7)"
                          fill="rgba(123,193,11,0.3)"
                        />
                      </g>
                    </g>
                    <g
                      transform="matrix(1, 0, 0, 1, 18, 2834)"
                      filter="url(#Rectangle_1158)"
                    >
                      <rect
                        id="Rectangle_1158-2"
                        data-name="Rectangle 1158"
                        width="66"
                        height="67"
                        rx="17"
                        transform="translate(6 3)"
                        fill="#86bb2f"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_2055"
                    data-name="Group 2055"
                    transform="translate(18 15.449)"
                    clipPath="url(#clip-path99)"
                  >
                    <path
                      id="Path_2194"
                      data-name="Path 2194"
                      d="M52.993,52.852a.922.922,0,0,0-.922-.922H46.543L44.7,53.773h6.45v4.607H40.092l-1.573,1.573a.919.919,0,0,0,.652.27h12.9a.922.922,0,0,0,.922-.922Z"
                      transform="translate(-22.721 -30.632)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2195"
                      data-name="Path 2195"
                      d="M52.605,28.137a.922.922,0,0,0-.922-.922h-12.9a.921.921,0,0,0-.922.922v3.686L39.7,29.98v-.922h.922l.622-.622a2.248,2.248,0,0,1,3.179,0l.622.622h5.714v4.607H48.808a2.234,2.234,0,0,1-.65,1.682L48,35.509h3.686a.922.922,0,0,0,.922-.922Z"
                      transform="translate(-22.333 -16.053)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2196"
                      data-name="Path 2196"
                      d="M51.684,76.646h-12.9a.921.921,0,0,0-.922.922v6.451a.921.921,0,0,0,.922.921h12.9a.921.921,0,0,0,.921-.921V77.568a.921.921,0,0,0-.921-.922M50.762,83.1H39.7V78.489H50.762Z"
                      transform="translate(-22.333 -45.211)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2197"
                      data-name="Path 2197"
                      d="M47.672,4.607H45.012V2.868A2.871,2.871,0,0,0,42.143,0H34.771A2.871,2.871,0,0,0,31.9,2.868V4.607H29.242a2.871,2.871,0,0,0-2.868,2.868V18.534h2.051V7.476a.819.819,0,0,1,.817-.817h18.43a.819.819,0,0,1,.818.817v34.1a.819.819,0,0,1-.818.818H29.242a.818.818,0,0,1-.817-.818V34.2H26.374v7.372a2.872,2.872,0,0,0,2.868,2.868h18.43a2.872,2.872,0,0,0,2.868-2.868V7.476a2.871,2.871,0,0,0-2.868-2.868m-4.711,0H33.954V2.868a.818.818,0,0,1,.817-.818h7.372a.819.819,0,0,1,.818.818Z"
                      transform="translate(-15.557 0)"
                      fill="#fff"
                    />
                    <path
                      id="Path_2198"
                      data-name="Path 2198"
                      d="M24.788,35.441,21.1,31.755a1,1,0,0,0-.744-.3,1.026,1.026,0,0,0-.732.328L8.37,43.9,5.436,40.97a1.025,1.025,0,0,0-1.45,0L.3,44.656a1.024,1.024,0,0,0,0,1.45l7.372,7.372a1.024,1.024,0,0,0,.725.3h.015a1.026,1.026,0,0,0,.731-.321L24.809,36.87a1.025,1.025,0,0,0-.021-1.429M8.377,51.282l-5.9-5.9,2.236-2.236,2.962,2.961a1.068,1.068,0,0,0,.744.3,1.022,1.022,0,0,0,.732-.328L20.4,33.957l2.229,2.229Z"
                      transform="translate(0 -18.553)"
                      fill="#fff"
                    />
                  </g>
                </svg>

                <h4>
                  Battery <br />
                  protection
                </h4>
                <p className="pr-5">
                  The e-bike battery is a unique, specialised piece of kit and
                  is often more expensive than the bike itself. Whether your
                  battery is damaged or stolen, it is covered at Velosure
                  regardless of whether the bicycle itself is also damaged so
                  you can rest easy.
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 d-sm-none oh bikeImageContainer">
            <img
              src={ebikeRight}
              className="whyChooseveloEbikeImg"
              alt="Why choose velosure for bike insurance?"
            />
          </div>
        </div>
      </div>
      <img
        src={ebikeRight}
        className="whyChooseveloEbikeImg d-none d-sm-block"
        alt="Why choose velosure for bike insurance?"
      />
    </div>
  );
};

export default WhyChooseVelosure;
